import React, { useState } from 'react';
import TabBar from '../../../component/tab-bar/tab-bar';
import { JournalEntriesReportsPage } from './tabs/journal-entries-reports-page';
import { JournalEntriesWaitingForReportPage } from './tabs/journal-entries-waiting-for-report-page';
import '../../settings/studies/studies.settings.css';

const tabs = ['דוחות', 'ממתין לדיווח'];

export const JournalEntriesPage = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const onTabSelected = (index: number) => {
    setSelectedIndex(index);
  };

  const elementTabs = [
    <JournalEntriesReportsPage />,
    <JournalEntriesWaitingForReportPage />,
  ];

  return (
    <div className={'studies-settings-root'}>
      <div style={{ width: '100%' }} className={'studies-settings-body-page'}>
        <div className={'studies-settings-title'}>פקודות יומן</div>

        <TabBar
          tabs={tabs}
          onClick={(index) => onTabSelected(index)}
          activeIndex={selectedIndex}
        />

        {elementTabs[selectedIndex]}
      </div>
    </div>
  );
};
